import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormBuilderService {

  constructor(private httpClient: HttpClient) { }

  public invokeApi(apiType: string, apiURL: any, values: any) {
    return this.httpClient[apiType](apiURL, values);
  }
  public saveForm(formData: any) {
    return this.httpClient.post('/Forms/SaveForm', formData);
  }

  public sendEmail(formData: any) {
    return this.httpClient.post('/EmailSender/sendEmailByTemplateId', formData);
  }
}
